module.exports = __webpack_public_path__ + "img/cg_logo.9ee6f531.png";